export default __webpack_public_path__ + "static/media/video_TVhost_poster.5b0d9855.jpg";